import React from 'react';
import actions from '../../state/actions/multi-currency';
import MultiCurrencyList from './multi-currency-list';

const _id = 'in-top-menu';

class MultiCurrencyTopMenuButton extends React.Component {
    constructor(props) {
        super(props);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (
            this.props.openId == _id &&
            this.wrapperRef &&
            !this.wrapperRef.contains(event.target)
        ) {
            this.props.dispatch(actions.closeMultiCurrencyDesktop());
        }
    }

    render() {
        const {
            dispatch,
            preferredCurrency,
            isCurrencyChosenByUser,
            currencies,
            openId
        } = this.props;
        if (!isCurrencyChosenByUser) {
            return null;
        }
        const open = openId === _id;

        const toggle = () => {
            const shouldBeOpen = !open;
            dispatch(
                shouldBeOpen
                    ? actions.openMultiCurrencyDesktop(_id)
                    : actions.closeMultiCurrencyDesktop()
            );
        };
        const selectCurrency = currency => () => {
            dispatch(actions.setPreferredCurrency(currency.code));
        };

        const selectedShortName = preferredCurrency
            ? preferredCurrency.shortName
            : '';

        // slim-header__menu-link px-3 align-items-center multi-currency-top-menu-item noselect
        // slim-header__menu-link px-3 d-flex align-items-center slim-header__menu-link--user

        return (
            <div
                className="slim-header__menu-link px-3 d-flex align-items-center multi-currency-top-menu-item noselect"
                onClick={toggle}
                ref={this.setWrapperRef}>
                <span className="slim-header__link-text">
                    {selectedShortName}
                </span>
                <span
                    className="slim-header__user-menu-icon arrow-down--after pl-1 col-auto d-none d-md-inline"
                    aria-hidden="true"
                />
                <div className="multi-currency-top-menu-item-dropdown">
                    <div
                        className={
                            ' multi-currency-selector-dropdown ' +
                            (open ? 'd-block' : 'd-none')
                        }>
                        <MultiCurrencyList
                            currencies={currencies}
                            selectedCurrencyCode={
                                preferredCurrency
                                    ? preferredCurrency.code
                                    : null
                            }
                            onCurrencySelected={selectCurrency}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default MultiCurrencyTopMenuButton;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/multi-currency/multi-currency-top-menu-button.jsx